
import AuthPage from "../../components/layout/authPage"
import { useState } from "react";
import { ThankU } from "../../components/thankYou";

export const ResetPasswordThankYouPage = () => {
    const [token, setTokens] = useState();
    return (
        <AuthPage>
          <ThankU
          title = "Success"
          text="A password reset link has been sent to your email."
          actionText="Go to Login"
          actionUrl="/login"

          />
        </AuthPage>
    )
}